import { createSlice } from "@reduxjs/toolkit";
import { LoaderState } from "../../utils/types/types";

const initialState: LoaderState = {
    loaderVisibleState: false
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader : (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export const { showLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
